import { PendingSampleCollectionProps, TestKitType } from "@/common/types";
import { RootState } from "@/redux/reducers";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CollectSample from "../test-detail/workflows/collect-sample";
import { getKitsPendingSampleCollection } from "@/redux/actions/homeActions";

const PendingSampleCollection: React.FC<PendingSampleCollectionProps> = ({
  updateStats,
}) => {
  const dispatch: any = useDispatch();

  const { kitsPendingSampleCollection } = useSelector(
    (state: RootState) => state.home
  );

  const updatePendingSampleCollection = () => {
    dispatch(getKitsPendingSampleCollection());
  };

  useEffect(() => {
    dispatch(getKitsPendingSampleCollection());
  }, []);

  return (
    <div className="w-full h-full flex flex-col border rounded-md">
      <p className="font-bold px-4 pt-4 pb-2 border-b">
        Kits Pending Sample Collection
      </p>
      {(kitsPendingSampleCollection as TestKitType[]).map((testKit) => (
        <div
          key={testKit.id}
          className="flex items-center justify-between gap-2 px-4 py-2"
        >
          <div>{testKit.kit_id}</div>
          <CollectSample
            testKitId={testKit.id}
            callback={() => {
              updatePendingSampleCollection();
              if (updateStats) {
                updateStats();
              }
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default PendingSampleCollection;
